
import { useState } from 'react';
import { toast } from 'sonner';
import { format } from 'date-fns';
import { UseNaturalLanguageInputResult } from '../types/calendar';
import { useOrchestratorAgent } from '@/hooks/useOrchestratorAgent';
import { OrchestratorAgentResponse, CalendarEventInfo } from '../types/orchestration';

export const useNaturalLanguageInput = (): UseNaturalLanguageInputResult => {
  const [naturalLanguageInput, setNaturalLanguageInput] = useState('');
  const { invokeAgent, isProcessing } = useOrchestratorAgent();

  const handleNaturalLanguageInput = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'Enter' || !naturalLanguageInput.trim()) return;
    
    try {
      toast.info("Processing your request...");
      
      const response = await invokeAgent({
        targetAgent: 'scheduling-agent',
        subIntent: 'createEventFromText',
        contextData: {
          naturalLanguageText: naturalLanguageInput,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          location: 'Phoenix, AZ'
        }
      }) as OrchestratorAgentResponse;
      
      // Fixed: Safe access to nested properties
      const parsedEvent = response?.metadata?.parsedEvent;
      
      if (parsedEvent) {
        toast.success("Event created successfully", {
          description: `${parsedEvent.title} from ${format(new Date(parsedEvent.start), 'PPpp')} to ${format(new Date(parsedEvent.end), 'PPpp')}`
        });
        setNaturalLanguageInput('');
      } else {
        toast.error("Couldn't parse your event details", {
          description: "Please try again with a clearer description including time and date."
        });
      }
    } catch (error) {
      console.error("Error parsing natural language:", error);
      toast.error("Failed to process your event");
    }
  };

  return {
    naturalLanguageInput,
    setNaturalLanguageInput,
    handleNaturalLanguageInput,
    isProcessing
  };
};
